// src/components/layout/Header.js
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import logoImage from '../../assets/images/logo.png'
const Header = () => {
  return (
    <HeaderContainer>
      <LogoContainer>
        <LogoImg src={logoImage} alt="Premier Granites Logo" />
      </LogoContainer>
      <CompanyName>Premier Granites</CompanyName>
      <Placeholder />
    </HeaderContainer>
  );
};

const HeaderContainer = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.8rem 1rem;
  background-color: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
`;

const LogoImg = styled.img`
  height: 40px;
  width: 40px;
`;

const CompanyName = styled.h1`
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0;
  text-align: center;
  color: #333;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
`;

// This empty div helps balance the header, making the company name appear centered
const Placeholder = styled.div`
  width: 40px;
`;

export default Header;